module.exports = __webpack_public_path__ + "img/icon_wodechouxuan.1cd22701.png";